import { useNavigate } from 'react-router';
import styled from '@emotion/styled';
import { useAuth } from 'src/hooks';
import { profileSettingsPageRoute } from 'src/routes/route-list';
import { UserPicture } from '../logic';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 1rem;
  margin-right: 1rem;
`;

export const ProfileButton = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <Container onClick={() => navigate(profileSettingsPageRoute)}>
      <UserPicture />
    </Container>
  );
};
